const normalizeText = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

export const buildSelectOptions = (items = []) =>
  (Array.isArray(items) ? items : []).map((item) => ({
    code: item.code || "",
    id: item.id || item.code || item.label,
    label: item.label || "",
    value: item.label || "",
  }));

export const buildUnitOptions = (items = []) => buildSelectOptions(items);

export const buildActOptions = (items = []) =>
  (Array.isArray(items) ? items : []).map((item) => ({
    code: item.code || "",
    id: item.id || item.code || item.label,
    name: item.label || "",
    value: item.label || "",
  }));

export const buildStatusOptions = (items = []) => buildSelectOptions(items);
export const buildCasePropertyTypeOptions = (items = []) =>
  buildSelectOptions(items);
export const buildVehicleReasonOptions = (items = []) =>
  buildSelectOptions(items);

export const matchOption = (options = [], value = "") => {
  const normalizedValue = normalizeText(value);

  if (!normalizedValue) {
    return null;
  }

  return (Array.isArray(options) ? options : []).find((option) => {
    const candidateValues = [
      option?.value,
      option?.label,
      option?.name,
      option?.code,
    ];

    return candidateValues.some(
      (candidateValue) => normalizeText(candidateValue) === normalizedValue
    );
  }) || null;
};

export const isOtherActOption = (option) => {
  const normalizedCode = normalizeText(option?.code);
  const normalizedName = normalizeText(option?.name ?? option?.label);

  return (
    normalizedCode.includes("other") ||
    normalizedName === "others acts" ||
    normalizedName === "other acts" ||
    normalizedName === "others" ||
    normalizedName === "other"
  );
};

export const matchOptionValue = (options = [], value = "") => {
  const matchedOption = matchOption(options, value);

  return matchedOption?.value || "";
};

const isCodeOrLabelMatch = (option, expectedCodeFragment, expectedLabels = []) => {
  const normalizedCode = normalizeText(option?.code);
  const normalizedLabel = normalizeText(option?.label ?? option?.value);

  return (
    normalizedCode.includes(normalizeText(expectedCodeFragment)) ||
    expectedLabels.some((label) => normalizedLabel === normalizeText(label))
  );
};

export const isVehicleCasePropertyType = (value = "", options = []) => {
  const matchedOption = matchOption(options, value);

  if (matchedOption) {
    return isCodeOrLabelMatch(matchedOption, "vehicle", ["vehicle"]);
  }

  return normalizeText(value) === "vehicle";
};

export const isOtherCasePropertyType = (value = "", options = []) => {
  const matchedOption = matchOption(options, value);

  if (matchedOption) {
    return isCodeOrLabelMatch(matchedOption, "other", ["other", "others"]);
  }

  return ["other", "others"].includes(normalizeText(value));
};

export const matchActOptionsByNames = (value = "", options = []) => {
  const names = String(value ?? "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

  return names.map((name) => {
    const normalizedName = normalizeText(name);
    const matchedOption = (Array.isArray(options) ? options : []).find((option) => {
      return [option?.name, option?.value, option?.code].some(
        (candidateValue) => normalizeText(candidateValue) === normalizedName
      );
    });

    return matchedOption || { code: "", id: name, name, value: name };
  });
};
